import React from "react";
import "./ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info?.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="eb-container">
        <div className="eb-card">
          <div className="eb-icon">!</div>
          <h1 className="eb-title">Oups, quelque chose s'est mal passé</h1>
          <p className="eb-text">
            L'application a rencontré une erreur inattendue. Vous pouvez
            essayer de recharger la page ou revenir à l'accueil.
          </p>
          {this.state.error && (
            <pre className="eb-detail">{String(this.state.error)}</pre>
          )}
          <div className="eb-actions">
            <button className="eb-btn eb-btn-primary" onClick={this.handleReload}>
              Recharger la page
            </button>
            <button className="eb-btn eb-btn-secondary" onClick={this.handleGoHome}>
              Retour à l'accueil
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
